import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '赛事直播', href: '/category/all' },
    { label: '赛程赛果', href: '/category/all' },
    { label: '新闻资讯', href: '/category/all' },
    { label: '平台评测', href: '/category/all' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2.5 shrink-0 cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center text-primary-500">
              <i className="ri-football-line text-2xl"></i>
            </span>
            <span className="font-heading font-bold text-lg md:text-xl text-foreground-900 whitespace-nowrap">
              2026世界杯
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="http://cefotiam.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-5 py-2.5 bg-accent-500 text-background-50 rounded-lg text-sm font-semibold transition-all duration-200 hover:bg-accent-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-vip-crown-line mr-1.5"></i>
              投注入口
            </a>
          </div>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <a
              href="http://cefotiam.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-4 py-3 mt-1 bg-accent-500 text-background-50 rounded-lg text-sm font-semibold text-center cursor-pointer"
            >
              <i className="ri-vip-crown-line mr-1.5"></i>
              投注入口
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}